/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Plan_Day_BInputs */

const en_features_plan_day_b = /** @type {(inputs: Features_Plan_Day_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day B · Upper`)
};

const pl_features_plan_day_b = /** @type {(inputs: Features_Plan_Day_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień B · Góra`)
};

/**
* | output |
* | --- |
* | "Day B · Upper" |
*
* @param {Features_Plan_Day_BInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_plan_day_b = /** @type {((inputs?: Features_Plan_Day_BInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Plan_Day_BInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_plan_day_b(inputs)
	return en_features_plan_day_b(inputs)
});